export const SELECT_ORDER_BLUEPRINT = 'SELECT_ORDER_BLUEPRINT';
export type SELECT_ORDER_BLUEPRINT = typeof SELECT_ORDER_BLUEPRINT;

export const ADD_ORDER_BLUEPRINT = 'ADD_ORDER_BLUEPRINT';
export type ADD_ORDER_BLUEPRINT = typeof ADD_ORDER_BLUEPRINT;

export const DELETE_ORDER_BLUEPRINT = 'DELETE_ORDER_BLUEPRINT';
export type DELETE_ORDER_BLUEPRINT = typeof DELETE_ORDER_BLUEPRINT;

export const SAVE_ORDER_BLUEPRINT = 'SAVE_ORDER_BLUEPRINT';
export type SAVE_ORDER_BLUEPRINT = typeof SAVE_ORDER_BLUEPRINT;

export const SUBMIT_ORDER = 'SUBMIT_ORDER';
export type SUBMIT_ORDER = typeof SUBMIT_ORDER;

export const SUBMIT_ORDER_FAILED = 'SUBMIT_ORDER_FAILED';
export type SUBMIT_ORDER_FAILED = typeof SUBMIT_ORDER_FAILED;

export const SUBMIT_ORDER_SUCCESS = 'SUBMIT_ORDER_SUCCESS';
export type SUBMIT_ORDER_SUCCESS = typeof SUBMIT_ORDER_SUCCESS;
